import { Account, Client, Functions, Locale, Storage, TablesDB, Teams } from 'appwrite';
import { appwriteConfig } from '../../config/environment';

export const client = new Client()
  .setEndpoint(appwriteConfig.endpoint)
  .setProject(appwriteConfig.projectId);

export const account = new Account(client);
export const functions = new Functions(client);
export const tablesDB = new TablesDB(client);
export const teams = new Teams(client);
export const storage = new Storage(client);
export const locale = new Locale(client);
